export default {
  empty: 'Nenhum dado para exibir',
};
